import { motion } from 'framer-motion';
import { Rocket, Infinity as InfinityIcon, Handshake, GraduationCap, Users, Clock } from 'lucide-react';

const benefits = [
  {
    icon: Rocket,
    title: 'Von Anfang an dabei',
    text: 'Berlin ist einer der jüngsten und am schnellsten wachsenden Standorte im HCP Netzwerk, wer heute einsteigt wächst gemeinsam mit dem Standort statt in einem fertigen Konzern eine feste Rolle auszufüllen.',
    highlight: true,
  },
  {
    icon: InfinityIcon,
    title: 'Ungedeckeltes Einkommen',
    text: 'Es gibt weder Gehaltsband noch Deckelung, deine Leistung entscheidet direkt und transparent darüber was du am Monatsende verdienst.',
  },
  {
    icon: Handshake,
    title: 'Selbstständig mit starkem Partner',
    text: 'Du führst dein eigenes Geschäft und hast gleichzeitig die komplette Infrastruktur eines etablierten Unternehmens im Rücken, von Backoffice über Compliance bis hin zu Produktzugang und Marke.',
  },
  {
    icon: GraduationCap,
    title: 'Strukturierte Ausbildung und Mentoring',
    text: 'Erfahrene Berater begleiten dich vom ersten Tag an, du erwirbst deine IHK Qualifikationen §34d und §34f und lernst am echten Fall statt an konstruierten Beispielen.',
  },
  {
    icon: Users,
    title: 'Akademiker als Klientel',
    text: 'Du berätst Mediziner, Ingenieure und Apotheker, also Menschen die zuhören, mitdenken und langfristig planen, statt Kaltakquise zu betreiben.',
  },
  {
    icon: Clock,
    title: 'Freie Zeiteinteilung',
    text: 'Du entscheidest wann und wie du arbeitest, ohne festen 9 to 5 Rhythmus und ohne Anwesenheitspflicht, denn selbstständig heißt bei uns wirklich selbstbestimmt.',
  },
];

const BenefitsSection = () => {
  return (
    <section id="warum" className="py-20 md:py-28">
      <div className="container mx-auto px-6">
        <div className="max-w-3xl mb-14">
          <p className="text-[11px] uppercase tracking-[0.22em] text-primary-dark font-semibold mb-4">Warum HCP</p>
          <h2 className="font-normal text-foreground mb-6">
            Wachse mit einem Team, das <span className="italic text-primary-dark">gemeinsam etwas aufbaut.</span>
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed">
            Die meisten Finanzhäuser sind längst fertig gebaut mit stehenden Prozessen und besetzten Positionen in denen du einfach nur eine vorgegebene Rolle ausfüllst, während du bei uns von Anfang an mitentscheidest wie diese Rollen aussehen und genau das die nächsten fünf Jahre deiner Karriere prägt.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {benefits.map((b, i) => (
            <motion.div
              key={b.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: 0.6, delay: i * 0.07 }}
              className={`premium-card p-7 ${b.highlight ? 'lg:col-span-1 border-primary/40 bg-primary/5' : ''}`}
            >
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-5 ${b.highlight ? 'bg-primary text-primary-foreground' : 'bg-primary/15 text-primary-dark'}`}>
                <b.icon className="w-5 h-5" strokeWidth={1.8} />
              </div>
              <h3 className="font-serif text-xl text-foreground mb-3">{b.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{b.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
